export default class IsDirtySet<Id extends string> {
  private _set: Set<Id> = new Set();

  flag(ids: Id[]) {
    ids.forEach((id) => this._set.add(id));
  }

  unflag(ids: Id[]) {
    ids.forEach((id) => this._set.delete(id));
  }

  has(id: Id) {
    return this._set.has(id);
  }

  getAll(): Id[] {
    return Array.from(this._set);
  }

  import(ids: Id[]) {
    ids.forEach((id) => this._set.add(id));
  }

  clear() {
    this._set = new Set();
  }
}
